import { Controller } from "react-hook-form";
import BasicSelect from "./index";

const FormBasicSelect = ({
    control,
    name,
    label,
    required,
    placeholder,
    disabled,
    options,
    helperText,
    onChange,
}) => {
    const handleChange = ({ name, value, onFieldChange }) => {
        onFieldChange(value);
        onChange && onChange(name, value);
    };
    return (
        <Controller
            control={control}
            name={name}
            render={({ field, fieldState }) => (
                <BasicSelect
                    label={label ?? ""}
                    required={required}
                    placeholder={placeholder}
                    name={field.name}
                    value={field.value ?? ""}
                    options={options}
                    helperText={helperText}
                    onChange={(value) =>
                        handleChange({
                            value,
                            name: field.name,
                            onFieldChange: field.onChange,
                        })
                    }
                    error={fieldState?.error?.message}
                    disabled={disabled}
                />
            )}
        />
    );
};

export default FormBasicSelect;
